


























































































































































































































































































































import router from "@/router";
import * as routes from "@/router/routes";
import { RootState } from "@/store";
import { LOGIN, VuexLoginRequest } from "@/store/modules/AuthenticationModule/actions";
import jwt_decode from "jwt-decode";
import moment from "moment";
import Vue from "vue";
import { mapState } from "vuex";

// Vue components
import AzureActiveDirectoryLoginButton from "@/components/AzureActiveDirectoryLoginButton.vue";
import Footer from "../App/Components/Footer.vue";
import RecoverAccountCard from "./ResetPassword/RecoverAccountCard.vue";

// Model
import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";
import { AuthResponseEnum } from "@/model/communication/auth/Login/AuthResponseEnum";
import { GetOrganizationCommand } from "@/model/communication/organizations/GetOrganizationCommand";
import { LoginModeType } from "@/model/data/organizations/LoginMode";
import { LocalStorageManager, LocalStorageRequests } from "@/plugins/LocalStorageManager";
import { LoginRequest } from "../../model/communication/auth/Login/LoginRequest";

export default Vue.extend({
    components: {
        Footer,
        AzureActiveDirectoryLoginButton,
        RecoverAccountCard,
    },
    data: () => ({
        LoginModeType,
        loading: false,
        username: "",
        password: "",
        mfa: "",
        isWindowsAuthentication: false,
        selectedPlugin: "",
        showServiceHostnameModalManual: false,
        AuthResponseEnum,
        externalUserGroups: null,
        usernameReqData: null,
        azureMode: false,
        currentStep: 1,
        gettingOrganization: false,
        userOrganization: null,
        radioGroup: 1,
        organizationName: null,
        organizationNotFound: false,
        showForgotPassword: false,
        autofill: false,
        intervalDetectAutofill: null,
        visiblePassword: false,
    }),
    watch: {
        isWindowsAuthentication(val: boolean) {
            if (val) this.selectedPlugin = undefined;
        },

        radioGroup(newValue) {
            if (newValue == 2) this.username = "";
            if (newValue == 1) this.organizationName = null;
            this.organizationNotFound = false;
        },

        isAzureADLogin(newValue) {
            if (newValue) {
                this.tryToGetUserdIdFromTokenJWTAndThenItsOrganization();
            }
        },
    },
    computed: {
        ...mapState({
            auth: (state: RootState) => state.authMod,
            startupData: (state: RootState) => state.application.startupData,
        }),

        selectedPluginArr: {
            get() {
                if (this.selectedPlugin) return [this.selectedPlugin];
                return [];
            },
            set(v: string[]) {
                if (v.length) this.selectedPlugin = v[0];
                else this.selectedPlugin = undefined;
            },
        },

        isNextToStep2Available() {
            if (this.radioGroup == 1 && (this.username == null || this.username.trim().length == 0)) return false;
            if (this.radioGroup == 2 && (this.organizationName == null || this.organizationName.trim().length == 0)) return false;
            return true;
        },

        isAzureADLogin() {
            if (this.$route != null && this.$route.query != null && this.$route.query.idToken != null) return true;
            if (LocalStorageManager.Read(LocalStorageRequests.AzureAccessToken) != null) return true;
            return false;
        },
        loginStyle() {
            if (this.$vuetify.breakpoint.smAndUp) return "border: thin solid rgba(0, 0, 0, 0.12); border-radius: 8px; padding: 48px 40px 40px 40px; background-color: white";
            return "";
        },
    },
    methods: {
        async doLogin() {
            const callbackURL = router.currentRoute.query["callbackURL"] ? (router.currentRoute.query["callbackURL"] as string) : routes.Root;
            if (!this.azureMode) this.usernameReqData = this.username;
            let req: VuexLoginRequest = {
                loginRequest: new LoginRequest(
                    this.usernameReqData,
                    this.password,
                    this.mfa,
                    this.isWindowsAuthentication,
                    this.selectedPlugin && this.selectedPlugin.length > 0,
                    this.selectedPlugin,
                    this.externalUserGroups,
                    null,
                    this.organizationName,
                    false
                ),
                callbackURL,
            };

            await this.$store.dispatch(LOGIN, req);
            if (this.auth.authState != AuthResponseEnum.MFARequired) {
                this.currentStep = 1;
                this.gettingOrganization = false;
                this.userOrganization = null;
                this.radioGroup = 1;
                this.mfa = "";
            }
        },

        async tryToGetUserdIdFromTokenJWTAndThenItsOrganization() {
            if (LocalStorageManager.Read(LocalStorageRequests.AzureAccessToken) != null) {
                let idToken = LocalStorageManager.Read(LocalStorageRequests.AzureAccessToken);
                // parso il token JWT e recupero id utente
                let decodedToken = jwt_decode(idToken);
                let parsedAzureUserId = decodedToken["oid"];
                let res = await new GetOrganizationCommand(parsedAzureUserId, null).execute();
                if (res.responseStatus == ApiResponseStatusEnum.Success && res.responseString != "GenericError") {
                    if (res.organizations != null && res.organizations.length > 0) this.userOrganization = res.organizations[0];
                }
            }
        },

        async goToStep2() {
            try {
                if (!this.gettingOrganization) {
                    this.gettingOrganization = true;
                    this.organizationNotFound = false;
                    this.isWindowsAuthentication = false;
                    this.azureMode = false;

                    if (this.username == "") this.username = null;
                    let res = await new GetOrganizationCommand(this.username, this.organizationName).execute();

                    if (res.responseStatus == ApiResponseStatusEnum.Success && res.responseString != "GenericError") {
                        if (res.organizations != null && res.organizations.length > 0) {
                            this.userOrganization = res.organizations[0];
                            LocalStorageManager.Write(LocalStorageRequests.UserOrganization, this.userOrganization.name);
                            this.currentStep = 2;
                        } else {
                            LocalStorageManager.Remove(LocalStorageRequests.UserOrganization);
                            this.organizationNotFound = true;
                        }
                    }

                    this.gettingOrganization = false;
                }
            } catch (error) {
                console.log("Something went wrong in GetOrganizationCommand()", error);
                this.gettingOrganization = false;
            }
        },

        goToStep1() {
            this.username = "";
            this.password = "";
            this.organizationName = "";
            this.organizationNotFound = false;
            this.radioGroup = 1;
            LocalStorageManager.Remove(LocalStorageRequests.UserOrganization);
            this.currentStep = 1;
        },

        getMinutesToDate(date: Date): number {
            let m = moment(date);
            const duration = moment.duration(m.diff(new Date()));
            return Math.floor(duration.asMinutes());
        },
        doAzureLogout() {
            this.authService.logout();
        },
        tryToLoginWithAzure(eventPayload) {
            // se sono riuscito a recuperare l'id dell'utente azure e i gruppi a cui appartiene
            if (eventPayload.azureUserId != null && eventPayload.azureUserId.length != null)
                if (eventPayload.azureUserGroupsIDs != null && eventPayload.azureUserGroupsIDs.length > 0) {
                    this.azureMode = true;
                    this.usernameReqData = eventPayload.azureUserId;
                    this.username = "";
                    this.password = "";
                    this.isWindowsAuthentication = true;
                    this.externalUserGroups = eventPayload.azureUserGroupsIDs;
                    this.doLogin();
                }
        },
        forgotPassword() {
            this.showForgotPassword = true;
        },
    },
    mounted() {
        this.intervalDetectAutofill = setInterval(() => {
            if (document.querySelectorAll('input[type="password"]:-webkit-autofill').length > 0) {
                this.autofill = true;
            }
        }, 100);
        setTimeout(() => {
            if (this.intervalDetectAutofill) {
                clearInterval(this.intervalDetectAutofill);
                this.intervalDetectAutofill = null;
            }
        }, 3000);

        if (this.startupData != null && !this.startupData.isSingleOrganizationInstallation)
            if (LocalStorageManager.Read(LocalStorageRequests.UserOrganization) != null) {
                this.radioGroup = 2;
                this.organizationName = LocalStorageManager.Read(LocalStorageRequests.UserOrganization);
                if (this.organizationName != null && this.organizationName.trim().length > 0) this.goToStep2();
            }
    },
});
